import { Component, OnInit, Input } from '@angular/core';
import { ReadinessTaskPriorityStatusDto } from "../../data/CommandServiceDtos.generated";

@Component({
  standalone: false,
  selector: 'project-readiness-stage',
  templateUrl: './project-readiness-stage.component.html',
  styleUrls: ['./project-readiness-stage.component.scss']
})
export class ProjectReadinessStageComponent implements OnInit {
  @Input() priority: ReadinessTaskPriorityStatusDto;

  constructor() { }

  ngOnInit() {
  }

  getCategoryDisplayName(categoryName: string): string {
    if (categoryName === 'MTL MOC' || categoryName === 'Task List MOC') {
      return 'MOC';
    }
    return categoryName;
  }

}
